/* =========================================================
   PRODUCT-FORM.JS — galería con zoom + selector de variantes + cantidad
   ========================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-root]').forEach(function (root) {

    var productData = JSON.parse(root.querySelector('[data-product-json]').textContent);

    /* ---------- Galería ---------- */
    var mainImg = root.querySelector('[data-gallery-main] img');
    var mainWrap = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.dataset.fullSrc || thumb.src;
          mainImg.srcset = '';
        }
      });
    });

    /* Zoom al hacer click / mover el mouse */
    if (mainWrap) {
      mainWrap.addEventListener('click', function () {
        mainWrap.classList.toggle('is-zoomed');
      });
      mainWrap.addEventListener('mousemove', function (e) {
        if (!mainWrap.classList.contains('is-zoomed')) return;
        var rect = mainWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      mainWrap.addEventListener('mouseleave', function () {
        mainWrap.classList.remove('is-zoomed');
      });
    }

    /* ---------- Selector de variantes ---------- */
    var optionInputs = root.querySelectorAll('[data-option-input]');
    var variantIdInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var comparePriceEl = root.querySelector('[data-product-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var buyNowBtn = root.querySelector('[data-buy-now]');

    function getSelectedOptions() {
      var selected = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        groups[input.dataset.optionPosition] = input.value;
      });
      Object.keys(groups).sort().forEach(function (k) { selected.push(groups[k]); });
      return selected;
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('es-MX', { style: 'currency', currency: productData.currency || 'MXN' });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut;
      }
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      // Actualiza la imagen si la variante tiene una asociada
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
      }

      // refleja selección en pills de tamaño / swatches deshabilitados
      root.querySelectorAll('[data-size-pill]').forEach(function (pill) {
        var testOptions = getSelectedOptions();
        var pos = parseInt(pill.dataset.optionPosition, 10);
        testOptions[pos] = pill.dataset.value;
        var match = productData.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === testOptions[i]; });
        });
        pill.classList.toggle('is-disabled', !!match && !match.available);
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.dataset.pillGroup) {
          root.querySelectorAll('[data-pill-group="' + input.dataset.pillGroup + '"]').forEach(function (el) {
            el.classList.remove('is-selected');
          });
        }
        if (input.dataset.swatchGroup) {
          root.querySelectorAll('[data-swatch-group="' + input.dataset.swatchGroup + '"]').forEach(function (el) {
            el.classList.remove('is-selected');
          });
        }
        var label = root.querySelector('[data-selected-label="' + input.name + '"]');
        if (label) label.textContent = input.value;
        updateVariant();
      });
    });

    // Delegación de click en pills/swatches (que contienen el input real)
    root.querySelectorAll('[data-pill-group], [data-swatch-group]').forEach(function (el) {
      el.addEventListener('click', function () {
        var input = el.querySelector('input');
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change')); }
        el.classList.add('is-selected');
      });
    });

    updateVariant();

    /* ---------- Selector de cantidad ---------- */
    var qtyInput = root.querySelector('[data-quantity-input]');
    root.querySelectorAll('[data-quantity-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    });
    root.querySelectorAll('[data-quantity-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    });

    /* ---------- Comprar ahora ---------- */
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var variant = findVariant();
        var qty = qtyInput ? qtyInput.value : 1;
        if (variant) window.location.href = '/cart/' + variant.id + ':' + qty + '?checkout';
      });
    }
  });

  /* ---------- Acordeón de descripción / detalles (details nativo, sin JS extra) ---------- */
})();
